import { render, staticRenderFns } from "./TemplateSingleLayout.vue?vue&type=template&id=3dc8cd81&scoped=true"
import script from "./TemplateSingleLayout.vue?vue&type=script&lang=js"
export * from "./TemplateSingleLayout.vue?vue&type=script&lang=js"
import style0 from "./TemplateSingleLayout.vue?vue&type=style&index=0&id=3dc8cd81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8cd81",
  null
  
)

export default component.exports